import React from 'react';
import { ContactBlock, ContactBlockHeaderProps } from '@jbhi-fi/components/src/ContactBlock';
import { ShopifySupportProvider } from '../../../../contexts/ShopifySupportContext';
import { useSupport } from '@jbhi-fi/components/src/context/SupportProvider';
import { styles } from './SupportBlock.css';
import { useIdPrefix } from '@jbhi-fi/components/src/IdPrefix';
import { getSalesLineHours } from '../../../../utils/salesLine/salesLine';
import { LegacyContactBlock } from '@jbhi-fi/components/src/ContactBlock/LegacyContactBlock/LegacyContactBlock';

export const SupportBlock = ({
  shouldShowSalesLineNumber,
  supportContactProps,
  isInstallationOffer = false,
}: {
  shouldShowSalesLineNumber: boolean;
  supportContactProps: ContactBlockHeaderProps;
  isInstallationOffer?: boolean;
}) => {
  const suffixId = isInstallationOffer ? 'installation-cta' : 'seenitcheaper-cta';
  return (
    <ShopifySupportProvider isInstallationOffer={isInstallationOffer}>
      <div id={useIdPrefix(suffixId)} className={styles.container}>
        <SupportContactBlock
          shouldShowSalesLineNumber={shouldShowSalesLineNumber}
          supportContactProps={supportContactProps}
          isInstallationOffer={isInstallationOffer}
        />
      </div>
    </ShopifySupportProvider>
  );
};

const SupportContactBlock = ({
  shouldShowSalesLineNumber,
  supportContactProps,
  isInstallationOffer = false,
}: {
  shouldShowSalesLineNumber: boolean;
  supportContactProps: ContactBlockHeaderProps;
  isInstallationOffer?: boolean;
}) => {
  const { phoneNumber, onCallClick, onChatClick } = useSupport();

  return window.Jbhifi.storeLocation === 'NZ' ? (
    <LegacyContactBlock
      chatOnClick={onChatClick}
      chatText="Live chat"
      callText={shouldShowSalesLineNumber ? `Call ${phoneNumber}` : ''}
      callOnClick={onCallClick}
      idComponent={isInstallationOffer ? 'installation' : undefined}
      salesLineHours={getSalesLineHours()}
      {...supportContactProps}
    />
  ) : (
    <ContactBlock
      chatOnClick={onChatClick}
      chatText="Live chat"
      shouldHideCallUs={!shouldShowSalesLineNumber}
      callText={shouldShowSalesLineNumber ? `Call ${phoneNumber}` : ''}
      callOnClick={onCallClick}
      idComponent={isInstallationOffer ? 'installation' : undefined}
      salesLineHours={getSalesLineHours()}
      shouldShowExclusionText={!isInstallationOffer}
      {...supportContactProps}
    />
  );
};
